export default function IMEIBasedSuccessRateTableBodyView() {
  let handleClickDownloadRawDataFromCell;

  const STATUS = {
    FAIL: 0,
    SUCCESS: 1,
    TOTAL: 2,
  };

  function createRows(weeks = {}, clients = {}, clientsInfo = {}) {
    const tableRows = [];
    const weeksASC = Object.keys(weeks).sort((a, b) => a.localeCompare(b));

    for (let clientCode in clients) {
      const client = clientsInfo[clientCode];

      let dayPropTdTags = [];
      for (let week of weeksASC) {
        const daysASC = Object.keys(weeks[week]).sort((a, b) =>
          a.localeCompare(b)
        );
        const daysASCWithTotal = [...daysASC, "Total"];

        let tempAggregation = {
          total: 0,
          success: 0,
          fail: 0,
          successRate: 0,
        };

        for (let day of daysASCWithTotal) {
          if (day.toLowerCase() !== "total") {
            const dayData = clients[clientCode]?.[week]?.[day] || {};

            if (!dayPropTdTags.length) {
              dayPropTdTags.push(
                m("td", client.clientCode),
                m("td", client.clientName)
              );
            }

            tempAggregation = {
              ...client,
              baseYMD: "Total",
              baseYW: dayData.baseYW,
              total: tempAggregation.total + (Number(dayData.total) || 0),
              success:
                tempAggregation.success + (Number(dayData.success) || 0),
              fail: tempAggregation.fail + (Number(dayData.fail) || 0),
              successRate: 0,
            };

            const tdTotal = m("td",
              dayData.total
                ? m(dayData.total > 0 ? "button" : "span",
                  {
                    class: dayData.total > 0 ? "btn btn-link p-0" : "",
                    onclick:
                      dayData.total > 0
                        ? () =>
                          handleClickDownloadRawDataFromCell(
                            dayData,
                            STATUS.TOTAL,
                            client,
                          )
                        : null,
                  },
                  dayData.total
                )
                : ""
            );

            const tdSuccess = m("td",
              dayData.total
                ? m(dayData.success > 0 ? "button" : "span",
                  {
                    class: dayData.success > 0 ? "btn btn-link p-0" : "",
                    onclick:
                      dayData.success > 0
                        ? () =>
                          handleClickDownloadRawDataFromCell(
                            dayData,
                            STATUS.SUCCESS,
                            client,
                          )
                        : null,
                  },
                  dayData.success
                )
                : ""
            );

            const tdFail = m("td",
              dayData.total
                ? m(dayData.fail > 0 ? "button" : "span",
                  {
                    class: dayData.fail > 0 ? "btn btn-link p-0" : "",
                    onclick:
                      dayData.fail > 0
                        ? () =>
                          handleClickDownloadRawDataFromCell(
                            dayData,
                            STATUS.FAIL,
                            client,
                          )
                        : null,
                  },
                  dayData.fail
                )
                : ""
            );

            const tdSuccessRate = m("td",
              dayData.total ? dayData.successRate : "_"
            );

            dayPropTdTags.push(tdTotal, tdSuccess, tdFail, tdSuccessRate);
          } else {
            if (!dayPropTdTags.length) {
              dayPropTdTags.push(
                m("td", tempAggregation.clientCode),
                m("td", tempAggregation.clientName)
              );
            }

            const successRate =
              Number(
                (
                  (tempAggregation.success / tempAggregation.total) *
                  100
                ).toFixed(2)
              ) || 0;
            tempAggregation = { ...tempAggregation, successRate };

            const tdTotal = m("td",
              tempAggregation.total
                ? m(tempAggregation.total > 0 ? "button" : "span",
                  {
                    class:
                      tempAggregation.total > 0 ? "btn btn-link p-0" : "",
                    onclick:
                      tempAggregation.total > 0
                        ? () =>
                          handleClickDownloadRawDataFromCell(
                            tempAggregation,
                            STATUS.TOTAL,
                            client,
                          )
                        : null,
                  },
                  tempAggregation.total
                )
                : ""
            );

            const tdSuccess = m("td",
              tempAggregation.total
                ? m(tempAggregation.success > 0 ? "button" : "span",
                  {
                    class:
                      tempAggregation.success > 0 ? "btn btn-link p-0" : "",
                    onclick:
                      tempAggregation.success > 0
                        ? () =>
                          handleClickDownloadRawDataFromCell(
                            tempAggregation,
                            STATUS.SUCCESS,
                            client,
                          )
                        : null,
                  },
                  tempAggregation.success
                )
                : ""
            );

            const tdFail = m("td",
              tempAggregation.total
                ? m(tempAggregation.fail ? "button" : "span",
                  {
                    class:
                      tempAggregation.fail > 0 ? "btn btn-link p-0" : "",
                    onclick:
                      tempAggregation.fail > 0
                        ? () =>
                          handleClickDownloadRawDataFromCell(
                            tempAggregation,
                            STATUS.FAIL,
                            client,
                          )
                        : null,
                  },
                  tempAggregation.fail
                )
                : ""
            );

            const tdSuccessRate = m("td",
              tempAggregation.total ? tempAggregation.successRate : "_"
            );

            dayPropTdTags.push(tdTotal, tdSuccess, tdFail, tdSuccessRate);
          }
        }
      }

      tableRows.push(m("tr.text-center.align-middle", dayPropTdTags));
    }

    return tableRows;
  }

  return {
    oninit: (vnode) => {
      handleClickDownloadRawDataFromCell = vnode.attrs.handleClickDownloadRawDataFromCell
    },

    view: (vnode) => {

      const { groupByWeeks, groupByClients, clientsInfo } = vnode.attrs.data;

      return m("tbody", createRows(groupByWeeks, groupByClients, clientsInfo))

    }
  }
}